module.exports = __webpack_public_path__ + "static/img/news-bg.9570e6a9.png";